// extracted by mini-css-extract-plugin
module.exports = {"fontSize":"FontSizeSelect_fontSize__2NCWh"};